<template>
  <div class="auth">
    <div class="banner"></div>
    <div class="help"></div>
    <div class="main">
      <div class="logo"></div>
      <div class="title">Complete your profile information.</div>

      <v-card flat="flat" class="card" :loading="loading">
        <v-card-text>
          <v-form v-model="valid" ref="form" lazy-validation>
            <div class="screen-profile">
              <v-avatar
                color="grey lighten-4"
                tile="tile"
                size="90"
                class="avatar"
              >
                <img
                  src="data:image/png;base64,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"
                  alt="avatar"
                />
              </v-avatar>

              <v-autocomplete
                v-model="profile.role"
                label="Please choose your user role*"
                :rules="fieldRules"
                :items="roleOptions"
                item-text="name"
                item-value="id"
              ></v-autocomplete>

              <v-text-field
                v-model="profile.fullname"
                label="Full Name*"
                type="text"
                :rules="fieldRules"
                required
              ></v-text-field>

              <v-radio-group
                v-model="profile.gender"
                row
                class="d-flex justify-content-sm-between"
              >
                <v-radio label="Male" value="0" color="#5f6f85"></v-radio>
                <v-radio label="Female" value="1" color="#5f6f85"></v-radio>
                <v-radio
                  label="Unspecified"
                  value="2"
                  color="#5f6f85"
                ></v-radio>
              </v-radio-group>

              <v-text-field
                v-model="profile.address"
                label="Address"
                type="text"
              ></v-text-field>

              <v-text-field
                v-model="profile.city"
                label="City*"
                type="text"
                :rules="fieldRules"
                required
              ></v-text-field>

              <v-autocomplete
                v-model="profile.country"
                label="Country*"
                :rules="fieldRules"
                :items="countryOptions"
                item-text="name"
                item-value="id"
                required
              ></v-autocomplete>

              <v-autocomplete
                v-model="profile.language"
                label="Language*"
                :rules="fieldRules"
                :items="languageOptions"
                item-text="name"
                item-value="id"
                required
              ></v-autocomplete>

              <v-autocomplete
                v-model="profile.timezone"
                label="Time Zone*"
                :rules="fieldRules"
                :items="timezoneOptions"
                item-text="name"
                item-value="id"
                required
              ></v-autocomplete>
            </div>

            <v-btn class="btn-submit" color="#2bb9aa" @click="updateProfile"
              >Register</v-btn
            >
            <div class="mt-5"></div>
          </v-form>
        </v-card-text>
      </v-card>

      <div class="lang">
        <lang-select></lang-select>
      </div>
    </div>
    <div class="grey-background"></div>
  </div>
</template>

<script>
import LangSelect from "./../../../components/LangSelect";
export default {
  created() {
    if (!this.$store.state.auth.signup_verified) {
      this.$router.push({ path: "/register" });
    }
  },

  components: {
    LangSelect
  },

  data: () => ({
    valid: false,
    loading: false,

    fieldRules: [value => !!value || "Required"]
  }),

  mounted() {
    // this.$store.dispatch('getAllUserRoles');
    this.$store.dispatch("getAllCountries");
    this.$store.dispatch("getAllLanguages");
    this.$store.dispatch("getAllTimezones");
  },

  computed: {
    profile() {
      return this.$store.state.user.profile;
    },
    roleOptions() {
      if (this.$store.state.auth.invited.uuid != '') {
        return [
          {
            id: 3,
            name: "I do not manage a team"
          }
        ];
      }
      return [
        {
          id: 2,
          name: "I manage a team"
        },
        {
          id: 3,
          name: "I do not manage a team"
        }
      ];
    },
    countryOptions() {
      return this.$store.getters.countries;
    },
    languageOptions() {
      return this.$store.getters.languages;
    },
    timezoneOptions() {
      return this.$store.getters.timezones;
    }
  },

  methods: {
    updateProfile() {
      if (!this.$refs.form.validate()) {
        return;
      }

      const data = {
        role: this.profile.role,
        fullname: this.profile.fullname,
        gender: this.profile.gender,
        address: this.profile.address,
        city: this.profile.city,
        country: this.profile.country,
        language: this.profile.language,
        timezone: this.profile.timezone
      };

      this.$store
        .dispatch("updateProfile", data)
        .then(() => {
          setTimeout(this.loginRoute, 500);
        })
        .catch(error => {
        });
    },

    register() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.loading = true;
      setTimeout(this.loginRoute, 1000);
    },

    loginRoute() {
      this.loading = false;
      this.$router.push({ path: "/login" });
    }
  }
};
</script>
